import React, { ComponentClass, PureComponent, ReactNode } from "react";
import Slider, { Settings } from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

// tslint:disable-next-line:no-empty-interface
export interface ISliderSettings extends Settings {}

const withSliderWrapper = (
  Component: React.ComponentType<ISliderSettings>
): ComponentClass<ISliderSettings> =>
  class SliderWrapper extends PureComponent<ISliderSettings> {
    public clientX: number = 0;
    public clientY: number = 0;
    public firstClientX: number = 0;
    public firstClientY: number = 0;

    public componentDidMount(): void {
      window.addEventListener("touchstart", this.touchStart);
      window.addEventListener("touchmove", this.preventTouch, {
        passive: false,
      });
    }

    public componentWillUnmount(): void {
      window.removeEventListener("touchstart", this.touchStart);
      window.removeEventListener("touchmove", this.preventTouch);
    }

    // tslint:disable-next-line:no-any
    public touchStart(e: any): any {
      this.firstClientX = e.touches[0].clientX;
      this.firstClientY = e.touches[0].clientY;
    }

    // tslint:disable-next-line:no-any
    public preventTouch(e: any): any {
      const minValue: number = 5; // threshold

      this.clientX = e.touches[0].clientX - this.firstClientX;
      this.clientY = e.touches[0].clientY - this.firstClientY;

      // Vertical scrolling does not work when you start swiping horizontally.
      // This event must be cancelable.
      if (Math.abs(this.clientX) > minValue && e.cancelable) {
        e.preventDefault();
        e.returnValue = false;

        return false;
      }

      return true;
    }

    public render(): ReactNode {
      return <Component {...this.props} />;
    }
  };

export default withSliderWrapper(Slider);
